import React from "react";
import styled from "styled-components";
import monoBankImage from "../../assets/monobank.png";
import theme from "../../styles/theme";

const DonateButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 4px;
  background: none;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  border: 1px solid ${theme.colors.grey};
  transition: all 0.1s linear;
  text-decoration: none;

  &:hover {
    background-color: #123753;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${theme.breakpointsCustom.lg}px) {
    display: ${({ showLinks }) => (showLinks ? "flex" : "none")};
  }
`;

const StyledSpan = styled.div`
  color: ${theme.colors.green};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
`;

const MonoBankImage = styled.img`
  width: 22px;
`;

const DonateLink = ({ showLinks }) => {
  return (
    <DonateButton
      href="https://send.monobank.ua/jar/59VfGdTtvE"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="link"
      showLinks={showLinks}
    >
      <StyledSpan style={{ textDecoration: "none" }}>
        <MonoBankImage src={monoBankImage}></MonoBankImage>Підтримати проєкт
      </StyledSpan>
    </DonateButton>
  );
};

export default DonateLink;
